module.exports = "/_next/static/images/phone-2x-5bd57474f209429346490888291ce27a.png.webp";